import { useCallback } from 'react';

export const useSound = () => {
  const playClickSound = useCallback(() => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      // Create a premium, crisp click sound (short transient tick/pop)
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      const filter = audioContext.createBiquadFilter();
      
      // High-pass filter for crispness
      filter.type = 'highpass';
      filter.frequency.setValueAtTime(1200, audioContext.currentTime);
      
      oscillator.connect(filter);
      filter.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      // Sharp, percussive envelope - very short duration
      oscillator.frequency.setValueAtTime(2400, audioContext.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(1800, audioContext.currentTime + 0.02);
      
      // Quick attack and decay for premium "tick" sound
      gainNode.gain.setValueAtTime(0.15, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.03);
      
      oscillator.type = 'sine';
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.03);
    } catch (error) {
      // Silently fail if audio context is not supported
      console.log('Audio not supported');
    }
  }, []);

  const playHoverSound = useCallback(() => {
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      
      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      
      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);
      
      // Very subtle hover sound
      oscillator.frequency.setValueAtTime(600, audioContext.currentTime);
      gainNode.gain.setValueAtTime(0.03, audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.05);
      
      oscillator.type = 'sine';
      oscillator.start(audioContext.currentTime);
      oscillator.stop(audioContext.currentTime + 0.05);
    } catch (error) {
      console.log('Audio not supported');
    }
  }, []);

  return { playClickSound, playHoverSound };
};
